import React, { useState } from "react";
import style from "./Accordian.module.css"

const Accordion = ({ title, content, width="50%", setisOpen=false }) => {
  const [isOpen, setIsOpen] = useState(setisOpen);

  return (
    <div className={style.accordion} style={{width:width}}>
      <button 
        className={style.accordionHeader} 
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={style.title}>{title}</span>
        <span className={`${style.arrow} ${isOpen ? style.rotate : ""}`}>&#9660;</span>
      </button>
      <div className={`${style.accordioncontent} ${isOpen ? style.open : ""}`}>
        {content}
      </div>
    </div>
  );
};

export default Accordion;
